<template>
  <div class="flex min-h-0 flex-1 flex-col gap-8 pt-8">
    <DetailHeader :title :icon @close="$emit('close')">
      <!-- Forward a custom header only when provided, so consumers passing a plain `title` still get the default <h2> fallback. -->
      <template v-if="$slots.header" #default>
        <slot name="header" />
      </template>
      <!-- Extra header controls, forwarded beside the ✕ (e.g. the article's extend button). -->
      <template v-if="$slots.actions" #actions>
        <slot name="actions" />
      </template>
    </DetailHeader>
    <LenisScroll viewport-class="flex-1">
      <slot />
    </LenisScroll>
  </div>
</template>

<script setup lang="ts">
import DetailHeader from '~/scopes/campaign/components/UI/DetailHeader.vue'
import LenisScroll from '~/scopes/campaign/components/UI/LenisScroll.vue'

defineProps<{ title?: string; icon?: string }>()
defineEmits<{ close: [] }>()

// Static header on top, scrollable body below: the close affordance stays in place while
// the content scrolls. The root fills its flex-column container. (Kept here rather than
// above the root element: a comment beside the root makes the render root a fragment,
// which quietly breaks an enclosing `<Transition>` — see `impacts/article/ArticleView.vue`.)
</script>
